import { theme } from '@intelie/ui'
import styled from 'styled-components'

export const BottomHelpText = styled.label`
    font-family: ${({ theme }) => theme['font-regular']};
    font-style: italic;
    font-size: 85%;
    color: ${({ theme }) => theme['gray-600']};
    line-height: 16px;
    padding-left: 6px;
    margin-top: 4px;
`

interface DivMainProps {
    variant: string
    error: boolean
    editMode: boolean
    border: boolean
    isArea:boolean
}
export const DivMain = styled.div<DivMainProps>`
    display: flex;
    width: auto;
    height: auto;
    vertical-align: middle;
    align-items: center;
    border: ${props =>
        props.variant === 'secondary' || props.border ? '1px solid ' + theme['gray-200'] : 'none'};
    transition: 0.3s;
    &:focus-within {
        background-color: ${props => (props.variant === 'secondary' ? props.theme['blue-200'] : 'transparent')};
    }
    &:focus {
        background-color: ${props => (props.variant === 'secondary' ? props.theme['blue-200'] : 'transparent')};
    }
    background: ${props =>
        props.variant === 'secondary' && !props.editMode
            ? props.theme['gray-0']
            : props.variant === 'secondary' && props.error
            ? props.theme['red-300']
            : 'transparent'};

    .primary_generalTextInput {
        &::-webkit-input-placeholder {
            color: ${({ theme }) => theme['gray-600']};
            vertical-align: middle;
        }

        &::-moz-input-placeholder {
            color: ${({ theme }) => theme['gray-600']};
            transform: scale(0.45);
            transform-origin: 0% 50%;
        }
        &:disabled {
            color: ${({ theme }) => theme['gray-1000']};
            background: ${({ theme }) => theme['gray-0']};
        }
        height: 44px;
        width: 100%;
        margin-top: 5px;

        background: ${props => (!props.editMode ? 'transparent' : props.theme['gray-0'])};
        font-style: normal;
        font-weight: normal;
        font-size: 85%;
        text-indent: 0.8%;

        border: 1px solid ${props => (props.error ? props.theme['red-500'] : props.theme['gray-500'])};
        border-radius: 3px;
        box-sizing: border-box;
    }
    .secondary_generalTextInput {
        &::-webkit-input-placeholder {
            color: ${props => props.theme['gray-600'] };
        }
        &::-moz-input-placeholder {
            color: ${props => props.theme['gray-600'] };
            vertical-align: top;
        }
        &:disabled {
            color: ${({ theme }) => theme['gray-1000']};
            cursor: default;
        }
        width: auto;
        height: ${({isArea}) => !isArea? "25px": "80px"};

        background: transparent;
        font-style: normal;
        font-weight: normal;
        font-size: 85%;
        /* text-indent: 5px; */

        padding: 0px;
        border: 0 none;
        outline: 0;
        box-shadow: 0 0 0 0;
        padding: 4px;
    }

    textarea.secondary_generalTextInput {
        margin: 8px 2px;
    }

    .aditionalInformationOnTop_generalTextInput {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        color: ${props => props.theme['red-500']};
        margin-left: 5px;
    }
`

export const TextBlock = styled.div`
    display: flex;
    align-items: center;
    align-self: middle;
    width: 100%;
    height: max-content;
    font-size: 14px;    
    border: 0 none;
`

export const Asterisk = styled.span`
    padding-left: 5px;
    color: ${({ theme }) => theme['red-700']};
`

export const Header = styled.div<{ variant: 'primary' | 'secondary' }>`
    display: flex;
    flex-direction: row;
    margin-top: 6px;
    margin-left: ${props => (props.variant === 'primary' ? '0px' : '2px')};
    width: max-content;
    overflow: hidden;
    height: min-content;
`

export const DivIcon = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
    overflow: visible;
    cursor: pointer;
    &:hover {
        .ctooltip {
            display: flex;
            visibility: visible;
        }
    }
`

export const Icon = styled.i`
    font-family: 'Font Awesome 5 Pro';
    font-style: normal;
    font-weight: 900;
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme['blue-500']};
    margin-left: 6px;
`

// Tooltip styles
interface TooltipDivProps {
    visibility?: string
}
export const TooltipDiv = styled.div<TooltipDivProps>`
    display: ${props => (props.visibility ? 'flex' : 'none')};
    flex-direction: column;
    align-items: center;
    visibility: ${props => (props.visibility ? props.visibility : 'hidden')};
    overflow: visible;
    position: absolute;
    max-height: 350px;
    padding-bottom: 5px;
    margin-left: 7px;
    bottom: 100%;
`

interface InfoBlockProps {
    color: string
    height?: number
    width?: number
    maxWidth?:string
}
export const InfoBlock = styled.div<InfoBlockProps>`
    display: inline-block;
    box-shadow: 0px 4px 16px rgba(54, 65, 89, 0.25);
    background: ${({color}) => color};
    border-radius: 2px;
    padding: 10px;
    height: ${ ({ height }) => height !== undefined ? `${height}px` : "max-content"};
    width: ${ ({ width }) => width !== undefined ? `${width}px` : "max-content"};
    max-width: ${({maxWidth}) => maxWidth};
`
export const ArrowDown = styled.div<InfoBlockProps>`
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid ${props => props.color};
    box-shadow: 0px 4px 16px rgba(54, 65, 89, 0.25);
    width: 0;
    height: 0;
`

export const InfoTextDiv = styled.div`
    font-family: ${({ theme }) => theme['font-regular']};
    font-size: 13px;
    line-height: 16px;
    color: ${({ theme }) => theme['gray-0']};
`

export const Title = styled.label`
    padding-left: 1.5px;
    line-height: 16px;
    color: ${({ theme }) => theme['gray-800']};
    font-family: ${({ theme }) => theme['font-semibold']};
`
